<!-- Main pane - projects, scenes, layers, etc. -->
<div id="main-map" [class.fdm-drag-drop-zone-hover]="uploadDragHover" 
  (drop)="mainService.dropFile($event);dragDropControl($event,false)" 
  (dragover)="dragDropControl($event,true)" 
  (dragenter)="dragDropControl($event,true)" 
  (dragleave)="dragDropControl($event,false)">

	<!-- Open/close navbar -->
  <div id="fdm-sidebar-switch"
    *ngIf="sidenav"
    [ngClass]="{ 'fdm-sidebar-switch-left': !sidenav.opened, 'fdm-sidebar-switch-right': sidenav.opened  }"
    [class.contextOffset]="!(fourD.activeUser && fourD.activeUser['showHoverPopups']) && contextNav.opened"
    (click)="sidenav.toggle()">
		<fa-icon [icon]="!sidenav.opened?'chevron-double-right':'chevron-double-left'"></fa-icon>
  </div>

  <!-- HTML dynamic selector item, used for all sorts of map selecting -->
  <div id="fdm-html-selector" style="top:-500px;left:-500px;"></div>
  <div id="fdm-pointer-selector" style="top:-500px;left:-500px;"></div>
  <!-- <div id="fdm-role-selector" *ngIf="viewRoleChanger > 5" style="z-index:999;position:absolute;right:5px;top:70px;width:200px;border:solid 2px #999;background-color:#eee;padding:2px;font-size:10px;">
      <mat-select [(ngModel)]="service.permissions.roleSelected" (selectionChange)="service.onRoleChange()">
        <mat-option *ngFor="let role of service.roles" [value]="role">{{ role | normaliseAcl | async}}</mat-option>
      </mat-select>
  </div> -->

  <div class="fdm-ui-boxes">
    <ng-container *ngFor="let n of uiManager.panels | keyvalue; let idx = index">
      <div *ngIf="n.value.show" [id]="n.value.id">
        <ng-container *ngIf="n.value.controller">
          <plugin-ui [plugin]="n.value.controller" [item]="n.value.controller.item"></plugin-ui>

          <!-- ctrl
          <ng-container *ngIf="!n.value.items">
            plugin
            
          </ng-container>
        
          <ng-container *ngIf="n.value.items && n.value.items.length > 0">
            items
            <div *ngFor="let item of n.value.items">
              <plugin-ui-section [plugin]="n.value.controller" [section]="item"></plugin-ui-section>
            </div>
          </ng-container> -->
        </ng-container>
        
      </div>
    </ng-container>
  </div>

  <div class="fdm-ui-boxes">
    <div *ngFor="let n of uiManager.activePanels; let idx = index" [id]="'ui_box_'+n.id">
      <ng-container *ngIf="n['plugin']">

        <ng-container *ngIf="!n.items">
          <plugin-ui [plugin]="n.plugin" [item]="n.item"></plugin-ui>
        </ng-container>
      
        <ng-container *ngIf="n.items && n.items.length > 0">
          <div *ngFor="let item of n.items">
            <plugin-ui-section [plugin]="n.plugin" [section]="item"></plugin-ui-section>
          </div>
        </ng-container>

      </ng-container>
      
    </div>
  </div>

  <div *ngFor="let n of infoBoxes; let idx = index" [id]="'info_box_'+idx" class="fdm-box-tiny fdm-tada" style="top:-500px;left:-500px;">
    <ng-container *ngIf="n.text">
      <span class="heading">{{ n.text }}</span>
    </ng-container>
    <ng-container *ngIf="n['props'] && n.props.length > 0">
      <table class="fdm-box-table" style="table-layout:fixed">
        <tr *ngFor="let prop of n.props">
          <td style="overflow-x:hidden">{{ prop.key }}</td>
          <td class="key" style="overflow-x:hidden">
            
            <div *ngIf="prop?.value?.popup ; else elseBlock">
              <button class="fdm-button fdm-linked" (click)="prop.value['show'] = !prop.value['show']">Show/hide</button>
              <div class="fdm-box-tiny fdm-tada" style="z-index:99999;position:absolute;width:400px;min-height:300px;" *ngIf="prop.value['show']">
                {{ prop.value.value }}
              </div>
            </div>
            <ng-template #elseBlock>{{ prop.value }}</ng-template>

          </td>
        </tr>
      </table>
    </ng-container>
    <ng-container *ngIf="n.image">
      <img vlink="image.png" [model]="n.image" class="full-width"/>
    </ng-container>
  </div>

  <xs-widget-popover [pluginController]="scenePlugins" [context]="this"></xs-widget-popover>
  <xs-widget-popover [pluginController]="cameraPlugins" [context]="this"></xs-widget-popover>
  <xs-widget-popover [pluginController]="basemapPlugins" [context]="this"></xs-widget-popover>

  <!-- Generic wait dialog (CSS controlled) -->
  <dialog-hang-on #hangon></dialog-hang-on>

  <!-- Navigation toolbar -->
  <app-nav-toolbar></app-nav-toolbar>

  <xs-camera-controller #cameraBookmarks></xs-camera-controller>

  <mat-sidenav-container class="full-height" [hasBackdrop]="false">

    <mat-sidenav id="sidenav" position="start" #sidenav mode="over" [opened]="mapService.currentProject"
      class="fdm-sidebar sidebar_outter light_color sidebar_float fdm-resizer">

      <!-- SIDE MENU -->
    <!-- <div id="sidebar-view-changer" style="background-color:#ccc;">

      <a *ngFor="let item of uiManager.uiModes" [id]="'guide-tab-'+item.id" class="navBut text-white">
        <fa-icon *ngIf="item.icon" style="margin-right:5px;" [icon]="item.icon"></fa-icon>
        <span *ngIf="item.labelToken">{{ item.labelToken | translate }} </span>
      </a>
      <hr>
    </div> -->

    <!-- <div class="large-icon-shortcuts" style="position:fixed;top:90px;left:420px;" *ngIf="mapService.currentProject && cameraPlugins">
      <ng-container *ngFor="let shortcut of cameraPlugins.listShortcuts(mapService.currentProject)">
        <span class="item" *ngIf="shortcut.show" [class.active]="shortcut.active" [matTooltip]="shortcut['tooltip'] | translate" (click)="cameraPlugins.component.clickPluginShortcut(shortcut,mapService.currentProject,$event)">
          <fa-icon [icon]="shortcut.icon"></fa-icon>
        </span>
      </ng-container>
    </div> -->

      <!-- resize sidenav; on hold for now
      <b class="fdm-link sizer" (mousedown)="canvasSizerDo($event)" (mousemove)="canvasSizerDoing($event)" (mouseup)="canvasSizerDone($event)">
        <fa-icon icon="arrows-alt-h"></fa-icon>
      </b> -->
      <!-- <button (click)="sceneController.sendReport();">report</button> -->

      <!-- Header section for projects -->
      <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons clearfix" *ngIf="mapService.currentProject">

        <ng-container *ngIf="uiManager.uiMode !== 'simple'">
          <li *ngFor="let item of gui.project_choices" 
              class="fdm-linked fdm-options-button pointer"
              id="project-settings"
              matTooltip="{{item.tooltip | translate}}"
              [routerLink]="item.router"
              (click)="item.onclick ? item.onclick.call(this) : return">
            <fa-icon [icon]="item.icon"></fa-icon>
          </li>
        </ng-container>

        <!-- Switch projects -->
        <h2>
          <span (click)="viewRoleChanger=viewRoleChanger+1">{{'NAV.MENU_PROJECT' | translate }}</span>
          <span *ngIf="mapService.currentProject && permissions?.can?.switch?.project" class="fdm-linked fdm-dropdown" [matMenuTriggerFor]="p_select">
              <i>{{mapService.currentProject?.name}}</i> <fa-icon icon="angle-down"  class=""></fa-icon>
            </span>
            <span *ngIf="!permissions?.can?.switch?.project" class="fdm-dropdown">
                <i>{{mapService.currentProject?.name}}</i>
              </span>
        </h2>

        <!-- Menu drop-down for projects -->
        <mat-menu #p_select="matMenu" [overlapTrigger]="false">
          <button mat-menu-item
            *ngFor="let p of fourD.projects"
            [routerLink]="['/app/projects/map',p.id]" > {{ p.name }}
          </button>
        </mat-menu>
      </div>

      <!-- Header section for scenes -->
      <div class="fdm-sidebar-header fdm-sidebar-header-middle fdm-buttons clearfix" *ngIf="mapService.currentProject && mapService.scene">

        <!-- <fa-icon icon="camera" (click)="openCameraBookmarks()"></fa-icon> -->

        <ng-container *ngIf="uiManager.uiMode !== 'simple'">

          <!--
          !-- Scene settings (options) --
          <li class="fdm-linked fdm-options-button pointer float-right" 
            [matTooltip]="'SCENE.OPTIONS' | translate" id="scene-options" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();">
            <fa-icon icon="cog"></fa-icon>
          </li>

          !-- Edit scene name --
          <mat-menu #menu="matMenu" [overlapTrigger]="false">
            <button mat-menu-item (click)="renameScene(mapService.scene)">
              <fa-icon icon="edit" style="font-size:26px;margin-right:16px;opacity:0.54;"></fa-icon>
              <span>{{ 'SCENE.EDIT_NAME' | translate }}</span> 
            </button>
            <mat-divider></mat-divider>
        
            !-- Set scene camera view --
              <button mat-menu-item (click)="setSceneCameraView()" *ngIf="mapService && mapService.currentProject && mapService.scene">
                <fa-icon icon="camera" style="font-size:26px;margin-right:16px;opacity:0.54;"></fa-icon>
                <span>{{ 'SCENE.CAMERA_VIEW' | translate }}</span>
              </button>
        
              !-- Set scene as default --
              <button mat-menu-item (click)="setSceneAsDefault()" *ngIf="mapService.scene.id != mapService.currentProject['lastActiveScene']">
                <fa-icon icon="check-square" style="font-size:26px;margin-right:16px;opacity:0.54;"></fa-icon>
                <span>{{ 'SCENE.SET_DEFAULT' | translate }}</span>
              </button>
        
              !-- Default scene --
              <button mat-menu-item disabled *ngIf="mapService.scene.id == mapService.currentProject['lastActiveScene']">
                <fa-icon icon="check-square" style="font-size:26px;margin-right:16px;color:rgb(207, 233, 207)"></fa-icon>
                <span>{{ 'SCENE.IS_DEFAULT' | translate }}</span>
              </button>
        
            !-- Delete scene --
              <button mat-menu-item (click)="deleteTransformGroup(mapService.scene)" *ngIf="permissions?.can?.delete?.scene">
                <fa-icon icon="trash" style="font-size:26px;margin-right:16px;opacity:0.54;"></fa-icon>
              <span>{{ 'SCENE.DELETE_SCENE' | translate }}</span>
            </button>
            
          </mat-menu>
        -->

          <!-- Scene options -->
          <ng-container *ngFor="let item of gui.scene_choices">
            
            <li *ngIf="item.menu" [matMenuTriggerFor]="menu" class="fdm-linked fdm-options-button pointer" matTooltip="{{item.tooltip | translate}}" id="scene-options">
              <fa-icon [icon]="item.icon"></fa-icon>
              <mat-menu #menu="matMenu">
                <ng-container *ngFor="let m of item.menu; let idx = index;">
                  <button *ngIf="m.allowed" mat-menu-item (click)="m.onclick ? m.onclick.call(this) : return">
                    <fa-icon *ngIf="m.icon" [icon]="m.icon"></fa-icon>
                    {{m.label | translate}}
                  </button>
                </ng-container>
              </mat-menu>
            </li>

            <li *ngIf="!item.menu" class="fdm-linked fdm-options-button pointer" matTooltip="{{item.tooltip | translate}}" [routerLink]="item.router"
              (click)="item.onclick ? item.onclick.call(this) : return">
              <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
            </li>
            
          </ng-container>

          <!-- Scene plugins on/off -->
          <li class="fdm-linked fdm-options-button pointer" id="scene-plugins">
            <fa-icon *ngIf="!showScenePlugins" icon="chevron-down" (click)="toggleScenePlugins()" [class.fdm-icon-selected]="scenePlugins.getActiveCount(mapService.scene)"></fa-icon>
            <fa-icon *ngIf="showScenePlugins" icon="chevron-up" (click)="toggleScenePlugins()"></fa-icon>
          </li>
          
        </ng-container>

        <!-- Default scene -->
        <h2>
          {{'MAP.MODES.SCENE' | translate }}
          <span *ngIf="permissions?.can?.switch?.scene" id="default-scene" class="fdm-linked fdm-dropdown" [matMenuTriggerFor]="s_select">
              <i>{{mapService.scene?.name}}</i> <fa-icon icon="angle-down"></fa-icon>
            </span>

            <!-- Switch scene -->
            <span *ngIf="!permissions?.can?.switch?.scene" class="fdm-dropdown">
                <i>{{mapService.scene?.name}}</i>
              </span>
        </h2>

        <!-- Menu drop-down for scenes -->
        <mat-menu #s_select="matMenu" [overlapTrigger]="false">
          <ng-container *ngIf="mapService.scenes">
              <button mat-menu-item *ngFor="let scene of mapService.scenes" (click)="_loadScene(scene.id)">
                {{ scene.name }}
              </button>
          </ng-container>
        </mat-menu>

        <span class="clearfix"></span>

        <ng-container *ngIf="uiManager.uiMode !== 'simple'">
          <div class="scene-shortcuts" [@slideUpDown] *ngIf="scenePlugins && showScenePlugins">
            <!-- Scene plugins -->
            <li class="fdm-linked fdm-options-button pointer">
              <fa-icon *ngIf="scenePlugins" class="fdm-layer-icon" icon="plug" style="color:#fff;"
              [id]="'plugin-hover-for-'+mapService.scene.id" [class.fdm-icon-selected]="scenePlugins.getActiveCount(mapService.scene)"
              (mouseover)="scenePlugins.component.mouseHover(mapService.scene,$event)" (mouseleave)="scenePlugins.component.mouseLeaveIcon(mapService.scene,$event)" (click)="scenePlugins.component.mouseHoverClick(mapService.scene,$event)"></fa-icon>
            </li>
            <ng-container *ngFor="let item of gui.scene_choices_deep">
            
              <li *ngIf="item.menu" [matMenuTriggerFor]="menu" class="fdm-linked fdm-options-button pointer" matTooltip="{{item.tooltip | translate}}" id="scene-options">
                <fa-icon [icon]="item.icon"></fa-icon>
                <mat-menu #menu="matMenu">
                  <ng-container *ngFor="let m of item.menu; let idx = index;">
                    <button *ngIf="m.allowed" mat-menu-item (click)="m.onclick ? m.onclick.call(this) : return">
                      <fa-icon *ngIf="m.icon" [icon]="m.icon"></fa-icon>
                      {{m.label | translate}}
                    </button>
                  </ng-container>
                </mat-menu>
              </li>
  
              <span *ngIf="!item.menu" class="item" matTooltip="{{item.tooltip | translate}}" [routerLink]="item.router" (click)="item.onclick ? item.onclick.call(this) : return">
                <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
                <span *ngIf="item.title">{{ item.title | translate }}</span>
              </span>
              
            </ng-container>

            <!-- <ng-container *ngFor="let shortcut of scenePlugins.listShortcuts(mapService.scene)">
              <span class="item" *ngIf="shortcut.show" [matTooltip]="shortcut['tooltip'] | translate" (click)="scenePlugins.component.clickPluginShortcut(shortcut,mapService.scene,$event)" [class.selected]="shortcut.active">
                <span class="checkbox"><fa-icon icon="check" *ngIf="shortcut.active"></fa-icon></span>
                <fa-icon [icon]="shortcut.icon"></fa-icon>
                <span>{{ shortcut['label'] | translate }}</span>
              </span>
            </ng-container> -->
          </div>
          <span class="clearfix"></span>
        </ng-container>

      </div>

      <!-- Cesium crash detector -->
      <ng-container *ngIf="mapService.currentProject && cesiumMapService.globes">
        <ng-container *ngFor="let m of cesiumMapService.globes | keyvalue">
          <!-- [{{ m.key}}] down=[{{ m.value.timeDown}}] since=[{{ m.value.timeSince}}] t_now=[{{ m.value.timeNow}}] m_now[{{ m.value.mouseNow}}] -->
          <div class="fdm-cesium-crash-detector fdm-shadow-large" *ngIf="m && m.value.timeDown > 3">
            <p>{{'CESIUM.DETECTOR.NOT_WORKING' | translate: { key:m.key } }}</p>
            <p>{{'CESIUM.DETECTOR.HINT' | translate }}</p>
            <button class="fdm-button" (click)="restartCesium(m.key)">{{'CESIUM.DETECTOR.RESTART' | translate }}</button>
            <button class="fdm-button" (click)="refreshBrowser(m.key)">{{'CESIUM.DETECTOR.REFRESH' | translate }}</button>
          </div>
        </ng-container>
      </ng-container>

      <!-- Tabs at the top of the project on the sidebar -->
      <div class="fdm-sidebar-header fdm-sidebar-header-secondary fdm-shadow fdm-sidebar-tabs fdm-padding-bottom-none" *ngIf="mapService.currentProject">

        <a *ngFor="let item of gui.main_tab" [id]="'guide-tab-'+item.id"
          class="navBut text-white"
          [routerLink]="item.router"
          matTooltip="{{item.tooltip | translate}}"
          [ngClass]="{'fdm-tab-selected':activeTab == item.id}"
          >
        <fa-icon *ngIf="item.icon" style="margin-right:5px;" [icon]="item.icon"></fa-icon>
        <span *ngIf="item.title">{{ item.title | translate }} 
          <span class="fdm-count" *ngIf="item.showCount">
            <span *ngIf="item.id == 'layers'">{{ mapService?.sceneTransforms?.length }}</span>
            <span *ngIf="item.id == 'annot'">{{ mapService?.annotations?.length }}</span>
            <!-- <span *ngIf="item.id == 'image'">{{ mapService.scene?._photo_count }}</span> -->
          </span>
        </span>

        <!-- <textarea style="width:100%;font-size:8px;height:200px;">{{ item | json }}</textarea> -->

        </a>

        <!-- Old version; keep until we're sure it's replaced nicely -->
        <a *ngIf="mapService.isAgronomeye"
            class="navBut text-white"
            [routerLink]="[ fourD.activeUser?'/app/projects/map':'/map', mapService.currentProject?.id,'agro']"
            [matTooltip]="'Agronomeye'"
            [ngClass]="{'fdm-tab-selected':activeTab == 'agro'}"
            >
          <fa-icon icon="wheat"></fa-icon>
        </a>
        <a *ngIf="isPP"
            class="navBut text-white"
            [routerLink]="[ fourD.activeUser?'/app/projects/map':'/map', mapService.currentProject?.id,'pp']"
            [matTooltip]="'Position Partners'"
            [ngClass]="{'fdm-tab-selected':activeTab == 'pp'}"
            >
          <fa-icon icon="truck"></fa-icon>
        </a>

      </div>


      <!-- middle / content section -->
      <div class="fdm-sidebar-body">

        <!-- we need to come up with a dynamic component injector mechanism here for the future -->
          <agro-list-comp    #agro       [hidden]="activeTab != 'agro' || !mapService.currentProject"></agro-list-comp>
          <pp-list-comp      #pp         [hidden]="activeTab != 'pp' || !mapService.currentProject"></pp-list-comp>
          <layers-list-comp  #layer      [hidden]="activeTab != 'layers' || !mapService.currentProject"></layers-list-comp>
          <insp-list-comp    #inspect    [hidden]="activeTab != 'annot' || !mapService.currentProject"></insp-list-comp>
          <!-- <library-comp      #library    [hidden]="activeTab != 'library' || !mapService.currentProject" *ngIf="fourD?.activeUser"></library-comp> -->
          <processing-comp   #processing [hidden]="activeTab != 'processing' || !mapService.currentProject"></processing-comp>
          
        
      </div>

      <!-- bottom section -->
      <div class="fdm-sidebar-dock" *ngIf="activeTab !== 'layers' && activeTab !== 'processing'">

        <button mat-icon-button
          style="width: 30px;"
          class=" light_color m-2"
          *ngIf="activeTab == 'agro'"
          [color]="'primary'"
          (click)="agroComp?.refreshSensors()"
          matTooltip=" 'MAP.REFRESH_SENSORS' | translate ">
          <fa-icon  style="font-size:18px;" icon="sync"></fa-icon>
        </button>

        <button mat-icon-button
          style="width: 30px;"
          class=" light_color m-2"
          *ngIf="activeTab == 'pp'"
          [color]="'primary'"
          (click)="ppComp?.refreshSensors()"
          matTooltip=" 'MAP.REFRESH_SENSORS' | translate ">
          <fa-icon  style="font-size:18px;" icon="sync"></fa-icon>
        </button>

        <!-- Download annotations -->
        <button mat-icon-button id="annotation-download"
          style="width: 30px;"
          class=" light_color m-2"
          *ngIf="activeTab == 'annot'"
          [color]="'primary'"
          (click)="inspect.downloadFiles()"
          [matTooltip]="'MAP.DOWNLOAD_DRAWINGS' | translate">
            <fa-icon  style="font-size:18px;" [icon]="['fal','download']"></fa-icon>
        </button>

        <!-- Annotations inspection report -->
        <button   *ngIf="activeTab == 'annot'" id="annotation-report"
                  style="width: 30px;"
        class="light_color m-2" (click)="inspect.openReport()" mat-icon-button color="primary"
          [matTooltip]="'MAP.REPORT_ADD' | translate" >
          <fa-icon [icon]="['far','file-edit']" style="font-size:18px;"></fa-icon>
        </button>

        <!-- Capture annotations screenshot -->
        <app-screenshot id="annotation-screenshot"></app-screenshot>

        <!-- Delete annotations -->
        <button style="width: 30px;" id="annotation-delete" mat-icon-button [matTooltip]="'GENERIC.DELETE' | translate"
          class="m-2" color="warn"
          *ngIf="inspect && activeTab == 'annot' && mapService?.canWrite"
          (click)="inspect.editing = !inspect.editing">
          <fa-icon style="font-size:18px;" [icon]="[inspect.editing?'fas':'far','trash']" ></fa-icon>
        </button>

      </div>
      
      <!-- Quick guides icon -->
      <app-quick-guides *ngIf="permissions?.can?.show_intro_tour?.site_settings && (uiManager.toggleQuickGuide$ | async)?.screen == 'map' && (uiManager.toggleQuickGuide$ | async)?.show" [context]="this"></app-quick-guides>

    </mat-sidenav>

    <!-- Details Side Nav -->
    <mat-sidenav position="end" [disableClose]="true" #detailsNav mode="over" [opened]="false" class="sidebar_outter mat-elevation-z4" [ngClass]="{sidebar_ghost:true || activeTab == 'agro'}">
    <!-- note: sidebar_outter (map.comp.scss) defines mostly the width of the sidebar -->

      <!-- <a *ngIf="mapService.scene && project" class="top-right" color="primary"
      [routerLink]="[fourD?.activeUser?'/app/projects/map':'/map',project?.id,activeTab]">
          <fa-icon style="font-size:18px;" [icon]="['far','times']"></fa-icon>
      </a>
      [mat-sidenav] -->
      <router-outlet></router-outlet>
      
    </mat-sidenav>

    <!-- Map View pane -->
    <mat-sidenav-content>

      <!-- cesium -->
      <map-viewer></map-viewer>

      <!-- 
        
        Fun idea; mini-map ... make it sync with the basemap for an alternative way of navigation, however there's a performance hit with Cesium
        but maybe see if we can do a Leaflet version, that might be interesting

        <div style="position:fixed;z-index:9999;width:300px;height:250px;right:15px;bottom:15px;">
        <map-viewer name="mini"></map-viewer>
      </div>

    -->
      
      <!-- Expand / collapse sidebar -->
      <camera-nav *ngIf="mapService.currentProject && cesiumMapViewer && fourD && fourD.activeUser && fourD.activeUser['showNavigator']" [class]="fourD?.activeUser['showNavigator'] ? '' : 'noshow'"></camera-nav>
      <position-nav *ngIf="cesiumMapViewer"></position-nav>
      <lock-camera *ngIf="currentCoord && (refPin?.show || mapService.newAnnotation)"></lock-camera>
      <app-keyboard-navigator></app-keyboard-navigator>
      <app-credit-notes></app-credit-notes>


      <!-- Splitting transform views (side by side) -->
      <div id="sideTransform" class="sideTransform noshow">
        <div class="leftSideTransform"> {{mapService.leftSideTransform}} </div>
        <div class="rightSideTransform"> {{mapService.rightSideTransform}} </div>
      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>
  <fdm-split-viewer #splitViewer></fdm-split-viewer>
  <fdm-tile-profiler #tileProfiler></fdm-tile-profiler>

</div>

<!-- Context Menu Side Nav -->
<mat-sidenav id="fdm-context-menu" position="start" [disableClose]="true" #contextNav mode="over" [opened]="false"
  class="fdm-floatbar-small sidebar_context mat-elevation-z2"
  [class.large]="this.viewPhotosLarge"
  [class.floating]="fourD.activeUser && fourD.activeUser['showContextMenuFloating']"
  [class.fixed]="fourD.activeUser && !fourD.activeUser['showContextMenuFloating']"
  [class.switchOffset]="fourD.activeUser &&!fourD.activeUser['showContextMenuFloating'] && !sidenav.opened">

  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">
    <li class="fdm-linked fdm-options-button pointer" (click)="contextNav.close()">
      <fa-icon icon="times"></fa-icon>
    </li>
    <h2>{{ 'MAP.ACTIONS' | translate }}</h2>
  </div>

  <!-- Add pin -->
  <div class="fdm-sidebar-body fdm-sidebar-content fdm-buttons">
    <li [matTooltip]="'MAP.ADD_POINT' | translate"
        class="fdm-linked fdm-options-button pointer" id="guide-pin-create"
        [routerLink]="['annot']">
      <fa-icon icon="map-marker-plus" ></fa-icon>
    </li>

    <li [matTooltip]="'MAP.SHOW_IMAGES' | translate"
        class="fdm-linked fdm-options-button pointer"
        [routerLink]="['image']">
      <fa-icon icon="images"></fa-icon>
    </li>
  </div>

</mat-sidenav>

<!-- the new photo-bucket as a component -->
<!-- <xs-photo-bucket></xs-photo-bucket> -->

<!-- Photos Side Nav (new, just leave here for now) -->
<mat-sidenav id="fdm-photo-bucket" position="start" [disableClose]="true" #photosNav mode="over" [opened]="false"
  class="fdm-floatbar-small sidebar_photos mat-elevation-z2" [class.large]="viewPhotosLarge" [class.show-bucket]="photosNav.opened">

  <div *ngIf="imageComp" class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    <!-- Close photo display window -->
    <li class="fdm-linked fdm-options-button pointer" (click)="photosNav.close()">
      <fa-icon icon="times"></fa-icon>
    </li>

    <!-- Delete photos -->
    <li *ngIf="mapService.scene?._photo_count > 0" class="fdm-linked fdm-options-button pointer" (click)="imageComp.nukePhotos()">
      <fa-icon icon="trash" class="fdm-layer-icon danger"></fa-icon>
    </li>

    <!-- Maximise / minimise photo display window -->
    <li class="fdm-linked fdm-options-button pointer" (click)="toggleBucket()">
      <fa-icon *ngIf="!this.viewPhotosLarge" icon="search-plus"></fa-icon>
      <fa-icon *ngIf="this.viewPhotosLarge" icon="search-minus"></fa-icon>
    </li>

    <li class="fdm-linked fdm-options-button pointer" *ngIf="mapService.scene?._photo_count > 0">
      <fa-icon id="guide-open-photogrammetry" [matTooltip]="'MAP.photogram' | translate" [routerLink]="['photogram']" (click)="detailsNav.open()" icon="cubes" *ngIf="permissions?.can?.see?.photogrammetry"></fa-icon>
      <fa-icon id="guide-open-photogrammetry" [matTooltip]="'MAP.photogram' | translate" icon="cubes" style="color:#ccc!important" *ngIf="!permissions?.can?.see?.photogrammetry"></fa-icon>
    </li>  

<!-- 2D images (photos) display pane -->
    <span class="fdm-layer"> {{ 'MAP.MODES.IMAGES' | translate }} <small>({{ mapService.scene?._photo_count }} {{'ENTITY.PHOTOS' | translate }})</small>

      <span *ngIf="mapService?.scene?._photo_count > 0" style="margin-left:20px;">

        <!-- Plot all photos -->
        <span class="fdm-checkboxes">
          <input [id]=" 'ic1' + mapService.scene.id" type="checkbox" class="fdm-checkbox" [(ngModel)]="mapService.showPhotos[mapService.scene.id]" (change)="imageComp.showHideAllPhotos($event.srcElement?.checked)" />
          <label [for]=" 'ic1' + mapService.scene.id"></label>
          <small>{{'MAP.PLOT_ALL_PHOTOS' | translate }}</small>
        </span>

        <!-- Filter by clicked position -->
        <span class="fdm-checkboxes" *ngIf="imageComp">
          <input [id]=" 'ic2' + mapService.scene.id" type="checkbox" class="fdm-checkbox" [(ngModel)]="imageComp['onlySelectedPositionPhotos']" (change)="imageComp.filterAndRefreshTargetedPhotos()" />
          <label [for]=" 'ic2' + mapService.scene.id"></label>
          <small>{{'MAP.PLOT_WITH_POSITION' | translate }}</small>
        </span>

        <!-- Clamp camera to ground -->
        <span class="fdm-checkboxes">
          <input [id]=" 'ic3' + mapService.scene.id" type="checkbox" class="fdm-checkbox" [(ngModel)]="imageComp.clampToGround" (change)="imageComp.clampingToGround()" />
          <label [for]=" 'ic3' + mapService.scene.id"></label>
          <small>{{ 'MAP.CLAMP_CAMERA' | translate }}</small>
        </span>

      </span>

    </span>

<!--    
  <mat-checkbox class="ml-2" *ngIf="mapService.scene?._photo_count > 0" [(ngModel)]="mapService.showPhotos[mapService.scene.id]" (change)="imageComp.showHideAllPhotos($event.checked)"> <small>{{'MAP.PLOT_ALL_PHOTOS' | translate }}</small></mat-checkbox>
  <mat-checkbox class="ml-2" *ngIf="mapService.scene?._photo_count > 0" [(ngModel)]="imageComponlySelectedPositionPhotos" (change)="imageComp.filterAndRefreshTargetedPhotos()"> <small>{{'MAP.PLOT_WITH_POSITION' | translate }}</small></mat-checkbox>
-->

  </div>

  <!-- Content -->
  <div class="fdm-sidebar-body fdm-sidebar-content" style="padding:15px 5px 0 13px !important;">

    <img-list-comp #images [class.noshow]="imageComp?.loading"></img-list-comp>

    <div  class="text-center" *ngIf="imageComp?.loading">
      <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
    </div>

  </div>

</mat-sidenav>


